import styled from 'styled-components';

import { Breakpoint, Color, FontWeight, Grid } from '../../enums';
import { StyledComponent } from '../../interfaces';

export const Container: StyledComponent<'div'> = styled.div``;

export const BackgroundItemContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 24px 0;
`;

export const BackgroundItem: StyledComponent<'img'> = styled.img`
  height: 152px;
`;

export const DecorationText: StyledComponent<'div'> = styled.div`
  font-weight: ${FontWeight.Medium};
  font-size: 40px;
  line-height: 44px;
  letter-spacing: -0.01em;
  color: ${Color.Black};
  width: 100%;
  max-width: ${Grid.DesktopHalf};

  @media ${Breakpoint.SmallMobile} {
    font-size: 30px;
    line-height: 38px;
  }
`;

export const NewsletterMolecule: StyledComponent<'div'> = styled.div``;

export const InputAndButtonContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
`;

export const Input: StyledComponent<'input'> = styled.input`
  border: 1px solid ${Color.Gray300};
  border-left: none;
  border-right: none;
  padding: 21px 0;
  width: 50%;
  font-weight: ${FontWeight.Light};
  font-size: 16px;
  line-height: 22px;
  color: ${Color.Black};

  &::placeholder {
    color: ${Color.Gray500};
  }
`;

export const Button: StyledComponent<'button'> = styled.button.attrs({ type: 'button' })`
  font-weight: ${FontWeight.Medium};
  font-size: 16px;
  line-height: 26px;
  text-decoration: underline;
  color: ${Color.Black};
`;

export const ButtonContainer: StyledComponent<'div'> = styled.div`
  border: 1px solid ${Color.Gray300};
  border-right: none;
  width: 50%;
  padding: 19px 0;
  text-align: right;
`;

export const AgreementContainer: StyledComponent<'div'> = styled.div`
  border-bottom: 1px solid ${Color.Gray300};
  padding: 22px 0;
  width: 100%;
`;
